/*
 * @Author: liji
 * @Date: 2022-10-25 20:31:01
 * @LastEditors: liji
 * @LastEditTime: 2022-10-26 14:39:32
 * @Description: file content
 */
/*eslint-disable*/
import JSEncrypt from "jsencrypt";

// 公钥
const PUBLIC_KEY =
	"MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCS3LSuG7ttWGvFV+Cn6FCKqqMxe9kF81McQO+tc4H5n1FImoeDDM28z1mnGGSqJHNAUbiRzcHYL8VAblH7Lbo7SwDnQtm+gjRIl9yUuyLBlA39ry14+dqCEXaO9N4hNOeRbZUXxTB126DkvKQOxzfoU1/mnDji0gUCy/zcB1KNOwIDAQAB";
// 私钥
const PRIVATE_KEY =
	"MIICdQIBADANBgkqhkiG9w0BAQEFAASCAl8wggJbAgEAAoGBAJLctK4bu21Ya8VX4KfoUIqqozF72QXzUxxA761zgfmfUUiah4MMzbzPWacYZKokc0BRuJHNwdgvxUBuUfstujtLAOdC2b6CNEiX3JS7IsGUDf2vLXj52oIRdo703iE055FtlRfFMHXboOS8pA7HN+hTX+acOOLSBQLL/NwHUo07AgMBAAECgYAhFtUmvVzXYCq4Bfq6Gh+7foLSbWMSciZxoTffTr0kLv8zao3JuyLHvbgna9mSdC/7d+4r+74HJYw93h1eiIkC5WbWKRqsCa3f3AU9fafYCMr52oOcdkkwP/kNisYWG/X1y8De58S2vMcHm4ZHqEYwzp89QAvj+a/USJGtdZQ8cQJBAPK4S398h0Ax77vGzx3fsG/zLEisxUNa8kHlrIULfMtQiPLeRqXj6/3sVDumsTVjgtAwBuC2ggVA8o3kws1hSe0CQQCa5cJ+zHc5yvr2siBpH5m/HaZpxXqSTe8BlAxcaWP8pGvuGTYDZI8cVMC55GEqiaefRbiQHK2cVE8Qvarn367HAkAVJqg1mNV0a6WXeHCuCsMmTkuKnbum7fL0eR46jdC3KvJ0L5h6dk0nWIPSmukQXPaWS8kdpenYqVs5sDilixfVAkAtbKGb87QnE5qDS/trOKQqwrQxooLucsJbcSIq25FB3qn0GhqX5h59zXDzUsEX62RntdeJE4/qH2NMYoLDGvqzAkAJLr0oBpOqinceFj/la9J8hUbiEjxEv+CNpH7Isg1McqfQVAxbHr1NPKg4+UL6f7GDMncDcLt2gPsGXhRvhkLK";
// 使用公钥加密
const encrypt = new JSEncrypt();
// encrypt.setPrivateKey('-----BEGIN RSA PRIVATE KEY-----'+PRIVATE_KEY+'-----END RSA PRIVATE KEY-----');
encrypt.setPublicKey(`-----BEGIN PUBLIC KEY-----${PUBLIC_KEY}-----END PUBLIC KEY-----`);

// 使用私钥解密
const decrypt = new JSEncrypt();
// decrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----');
decrypt.setPrivateKey(`-----BEGIN RSA PRIVATE KEY-----${PRIVATE_KEY}-----END RSA PRIVATE KEY-----`);

// 加密
export const getEncodeText = (originStr) => {
	const PASS_SALT = "https://www.mearitek.com/zh/home-cn/";
	return encrypt.encrypt(originStr + PASS_SALT);
};

// 解密
export const getDecodeText = (excodeText) => {
	return decrypt.decrypt(excodeText);
};

/* token 加密解密 */
const TOKEN_PUB_KEY =
	"MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQClkYmV0VKZ+QQaJbgmWQ3bFfIWFsEdKnZyoEP7GbiIQ+ffJD+PKo/m47g4PSgJvYgiRBV8rgZrsHT8B74AzZ+7kFcQ7DIxAudFQD5jkeWkfh8rHvTf/rhP8WlmFMuYvXBygygDX7fP5N0v6oAMus7J4FL1vuAWRXYaJ4B3fcXlXwIDAQAB";
const TOKEN_PRI_KEY =
	"MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAKWRiZXRUpn5BBoluCZZDdsV8hYWwR0qdnKgQ/sZuIhD598kP48qj+bjuDg9KAm9iCJEFXyuBmuwdPwHvgDNn7uQVxDsMjEC50VAPmOR5aR+Hyse9N/+uE/xaWYUy5i9cHKDKANft8/k3S/qgAy6zsngUvW+4BZFdhongHd9xeVfAgMBAAECgYBs4pW1LYBBOn70IzJEJfTyzC/1TumZoL9dCwEqNfQhyWbIXTJfmQIiOkiA09ds8HSC9HudD2WxlM6aoQzXwmL1Bj8jskVCn2fnEebONeSTgrTKXxGnmotlSpoigIC9gjEFfTzKupHDk07+P9HDuaU+QmzIyi+IvmEM13K+ylAjgQJBAP6avKeLjgJhTKialNbyVatxjwoFoxD4gmn8le005kOt5vQn7iGFQSrYKS5ncnFOh97E5XVK8m//WDB9fpCOEs8CQQCmed1S4G+z+0bd1fAPQOU+Wc5tY1S1wYOy6ClmgZZmMQZmw2dJGYz2TdBPhM1xbwJ0Ge+N1uL8J/p732qCvOhxAkEAxyXFts/j7lypF6CCF3dKJ2YV2mL6X8XiTICzzOz5x6p44jVxgGq4xIh7/b4QuCwS/t7IFGzhIVV7Z8JhgzR95QJAE4qolUrtMdZkOjQbyt6WSlxmY+bOEcvWdtDT00mQ6wwEMVnsrOMH7f2yXzM6nn8mbZSBz0eTO4BB4fqW2SPtsQJAcN6cM+3pPDJGrjs0AxwZTId/BKZ+UvjUNxMoWcQ6KbK1zcZLpRsa9yIPIInpUnZSFoNVCPnSh9J0oVRlmiZNJw==";

// 使用私钥解密
const tokenDecrypt = new JSEncrypt();
// decrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----');
tokenDecrypt.setPrivateKey(
	`-----BEGIN RSA PRIVATE KEY-----${TOKEN_PRI_KEY}-----END RSA PRIVATE KEY-----`
);

// 解密token
export const decodeToken = (excodeToken) => {
	return tokenDecrypt.decrypt(excodeToken);
};
